
    <ng-container *ngIf="entity">
      <ng-container [ngSwitch]="entity.device_widget_type()">
        <device-entity-widget
          *ngSwitchCase="DeviceWidgetEnum.DEVICE_WIDGET__ENTITY"
          (widgetEvent)="forwardEvent($event)"
          [entity]="entity"
          [layout]="layout"
          [options]="options"
        ></device-entity-widget>
        <device-target-widget
          *ngSwitchCase="DeviceWidgetEnum.DEVICE_WIDGET__ENVIRONMENT_TARGET"
          (widgetEvent)="forwardEvent($event)"
          [entity]="entity"
          [layout]="layout"
          [options]="options"
        ></device-target-widget>
      </ng-container>
    </ng-container>
  